exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "order-form .csas-appointment-section--high {\n  border: 1px solid #BDE4F9;\n  border-radius: 4px;\n  background-color: #dff2fd;\n  padding: 50px 15px;\n}\n\norder-form .csas-appointment-section--info > * {\n  text-align: left;\n  padding-left: 80px;\n  margin-bottom: 20px;\n  min-height: 48px;\n}\n", ""]);

// exports
